import { render, staticRenderFns } from "./LiveloTab.vue?vue&type=template&id=748b03ee&scoped=true&"
import script from "./LiveloTab.vue?vue&type=script&lang=js&"
export * from "./LiveloTab.vue?vue&type=script&lang=js&"
import style0 from "./LiveloTab.vue?vue&type=style&index=0&id=748b03ee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b03ee",
  null
  
)

export default component.exports